export default "__VITE_ASSET__CTt6d4xx__"